// ** Icon imports
import HomeIcon from "mdi-material-ui/Home";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import HelpIcon from "@mui/icons-material/Help";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import HouseIcon from "@mui/icons-material/House";
import CategoryIcon from "@mui/icons-material/Category";
import CollectionsIcon from "@mui/icons-material/Collections";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ArticleIcon from "@mui/icons-material/Article";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";
import SettingsIcon from "@mui/icons-material/Settings";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import WebIcon from "@mui/icons-material/Web";

const navigation = () => {
  return [
    { sectionTitle: "Dashboard" },
    {
      title: "Dashboard",
      icon: HomeIcon,
      path: "/dashboard",
    },

    { sectionTitle: "Website Management" },
    {
      title: "Landing Pages",
      icon: WebIcon,
      path: "/landing-pages",
    },
    {
      title: "Home Details",
      icon: HouseIcon,
      path: "/home-details",
    },
    {
      title: "Service Types",
      icon: MiscellaneousServicesIcon,
      path: "/service-types",
    },
    {
      title: "AMC Packages",
      icon: FormatQuoteIcon, // Or a better package icon if imported
      path: "/amc-packages",
    },
    {
      title: "Banner Images",
      icon: PermMediaIcon,
      path: "/banner-images",
    },
    {
      title: "Gallery",
      icon: CollectionsIcon,
      path: "/gallery",
    },
    {
      title: "Performax",
      icon: CategoryIcon,
      path: "/performax",
    },
    {
      title: "Workshop",
      icon: AddHomeWorkIcon,
      path: "/workshop",
    },
    {
      title: "Settings",
      icon: SettingsIcon,
      path: "/settings",
    },

    { sectionTitle: "User Inquiries & Orders" },
    {
      title: "Service Inquiries",
      icon: MiscellaneousServicesIcon,
      path: "/service",
    },
    {
      title: "AMC Subscriptions",
      icon: CardMembershipIcon,
      path: "/amc-orders",
    },
    {
      title: "Franchise Inquiries",
      icon: HelpIcon,
      path: "/inquiry",
    },
    {
      title: "Contacts",
      icon: RecentActorsIcon,
      path: "/contact",
    },
    {
      title: "Bulk Orders",
      icon: AddShoppingCartIcon,
      path: "/bulk-orders",
    },

    { sectionTitle: "Content Management" },
    {
      title: "Blog",
      icon: ArticleIcon,
      path: "/blogs",
    },
    {
      title: "Testimonials",
      icon: FormatQuoteIcon,
      path: "/testimonials",
    },
    {
      title: "SEO Details",
      icon: ScreenSearchDesktopIcon,
      path: "/seo",
    },
  ];
};

export default navigation;
